<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--accordion start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-md-0 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--accordion end-->

</div>

<!--body content end--> 
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shortcode-accordion",
        }
    }
}
</script>